import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { LfsaBotonEditarGridComponent } from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SharedModule } from '../../shared/shared.module';
import { LogisticaRoutingModule } from './logistica-routing.module';
import { TrackingPlanificacionComponent } from './view/tracking-planificacion/tracking-planificacion.component';
import { CheckGaritaComponent } from './view/check-garita/check-garita.component';
import { CheckVehicularComponent } from './view/check-vehicular/check-vehicular.component';
import { TrackingAndenComponent } from './view/tracking-anden/tracking-anden.component';
import { TrackingDocumentosComponent } from './view/tracking-documentos/tracking-documentos.component';
import { TrackingConvoyComponent } from './view/tracking-convoy/tracking-convoy.component';
//T.32832 - Import del componente tracking-adm
import { TrackingAdmComponent } from './view/tracking-adm/tracking-adm.component';
import { TrackingCamionComponent } from './view/tracking-camion/tracking-camion.component';

//T.32832 - Ampliacion de funcionalidades de planificacion
import { TipoPlanificacionComponent } from './view/tipo-planificacion/tipo-planificacion.component';
import { AreasLogisticaComponent } from './view/areas-logistica/areas-logistica.component';
import { CheckDinamicoComponent } from './component/check-dinamico/check-dinamico.component';
import { BitacoraHistoricoComponent } from './component/bitacora-historico/bitacora-historico.component';
import { ReporteBitacoraComponent } from './view/reporte-bitacora/reporte-bitacora.component';
import { ViewAlldocComponent } from './view/view-alldoc/view-alldoc.component';
import { MarquesinasComponent } from './view/marquesinas/marquesinas.component';
import { MarquesinaMensajesComponent } from './view/marquesina-mensajes/marquesina-mensajes.component';
import { ConfiguracionGeneralComponent } from './view/configuracion-general/configuracion-general.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditarViajeComponent } from './view/editar-viaje/editar-viaje.component';
import { CancelarViajeComponent } from './view/cancelar-viaje/cancelar-viaje.component';
import { UploadCsvPlanificacionComponent } from './view/upload-csv-planificacion/upload-csv-planificacion.component';
import { TrackingConvoyCierreComponent } from './view/tracking-convoy-cierre/tracking-convoy-cierre.component';
import { CheckGaritaSalidaComponent } from './view/check-garita-salida/check-garita-salida.component';
import { LogPedidoDepuraComponent } from './view/log-pedido-depura/log-pedido-depura.component';


@NgModule({
  declarations: [
    TrackingPlanificacionComponent,
    CheckGaritaComponent,
    CheckVehicularComponent,
    TrackingAndenComponent,
    TrackingDocumentosComponent,
    TrackingConvoyComponent,
    //T.32832 - Declaración del componente tracking-adm
    TrackingAdmComponent,
    TrackingCamionComponent,
    TipoPlanificacionComponent,
    AreasLogisticaComponent,
    CheckDinamicoComponent,
    BitacoraHistoricoComponent,
    ReporteBitacoraComponent,
    ViewAlldocComponent,
    MarquesinasComponent,
    MarquesinaMensajesComponent,
    ConfiguracionGeneralComponent,
    EditarViajeComponent,
    CancelarViajeComponent,
    UploadCsvPlanificacionComponent,
    TrackingConvoyCierreComponent,
    CheckGaritaSalidaComponent,
    LogPedidoDepuraComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    LogisticaRoutingModule,
    NgSelectModule,
  ]
})
export class LogisticaModule { }
